import { render, staticRenderFns } from "./BaseDropzone.vue?vue&type=template&id=7ab7dae1"
import script from "./BaseDropzone.vue?vue&type=script&lang=js"
export * from "./BaseDropzone.vue?vue&type=script&lang=js"
import style0 from "./BaseDropzone.vue?vue&type=style&index=0&id=7ab7dae1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports